import * as Yup from 'yup'

export const getValidationSchema = () =>
  Yup.object().shape({
    supplierCode: Yup.mixed()
      .required('Furnizorul este un câmp necesar'),
    supplierName: Yup.string()
      .required('Furnizorul este un câmp necesar'),
    truckNumber: Yup.string()
      .matches(
        /^[A-Za-z0-9]+$/,
        'Numărul camionului poate conţine doar litere şi cifre! Exemplu: IF01ABC'
      )
      .required('Numărul de înmatriculare este un câmp necesar'),
    driverName: Yup.string()
      .required('Șoferul este un câmp necesar')
  })

export const initialValues = {
  supplierCode: null,
  supplierName: '',
  truckNumber: '',
  driverName: ''
}
